// Mock data for ImpacTech Digital website

export const mockServices = [
  {
    id: 1,
    title: "Website Design & Development",
    description: "Visually striking, user-friendly websites from concept to launch."
  },
  {
    id: 2,
    title: "CRM Implementation",
    description: "Setup/integration of CRM systems across the customer lifecycle."
  },
  {
    id: 3,
    title: "Content Creation",
    description: "Engaging articles, videos and graphics that communicate the brand."
  },
  {
    id: 4,
    title: "Mobile App Development",
    description: "Custom iOS/Android apps focused on usability."
  },
  {
    id: 5,
    title: "Lead Generation & Automation",
    description: "Tools that capture, nurture and convert leads automatically."
  },
  {
    id: 6,
    title: "Advertising",
    description: "Strategic ad campaigns across channels to boost awareness and sales."
  },
  {
    id: 7,
    title: "Marketplace Account Setup & Listing",
    description: "Set up and list products on online marketplaces."
  },
  {
    id: 8,
    title: "Social Media Marketing (SMM)",
    description: "Organic + paid social to grow brand and traffic."
  },
  {
    id: 9,
    title: "Search Engine Optimization (SEO)",
    description: "On-page/off-page optimization for organic traffic."
  },
  {
    id: 10,
    title: "Brand Kit",
    description: "Logos, color palettes, typography and guidelines for consistency."
  },
  {
    id: 11,
    title: "Email Marketing",
    description: "Targeted, often-automated email campaigns."
  },
  {
    id: 12,
    title: "Company Profile & Brochure Design",
    description: "Professional profiles and brochures."
  },
  {
    id: 13,
    title: "Packaging Design",
    description: "Appealing, functional packaging that boosts brand identity."
  },
  {
    id: 14,
    title: "Logo Design",
    description: "Unique, memorable logos as the cornerstone of the brand."
  },
  {
    id: 15,
    title: "Business Card Design",
    description: "Impactful cards that make a strong first impression."
  },
  {
    id: 16,
    title: "E-Commerce Portal Development",
    description: "Robust online stores with payment gateways and inventory."
  },
  {
    id: 17,
    title: "UI/UX Design",
    description: "Intuitive, engaging interfaces and experiences."
  },
  {
    id: 18,
    title: "IT Resource Outsourcing",
    description: "Access to skilled IT professionals without in-house hiring."
  },
  {
    id: 19,
    title: "Cyber Security",
    description: "Protecting systems, networks and data from digital attacks."
  },
  {
    id: 20,
    title: "Cloud Services (Azure, AWS)",
    description: "Cloud migration, hosting and infrastructure management on Azure and AWS for scalable, secure operations."
  },
  {
    id: 21,
    title: "AI & Chatbot Integration",
    description: "Intelligent AI assistants and chatbots integrated into your website and workflows to engage customers and automate support 24/7."
  },
  {
    id: 22,
    title: "Zoho Implementation & Consulting",
    description: "End-to-end Zoho consulting — CRM, Zoho One, Books & more. Implementation, customization, migration and training.",
    link: "/zoho"
  }
];

export const mockClients = [
  "Al Arabiya Group",
  "Business Baker",
  "Biz Hype Zone",
  "DEIZ",
  "Fusion Frame",
  "Cleritbiz",
  "Luminor Tech",
  "Smart Biz",
  "Achievers Zone",
  "TVG Management Consultancy",
  "Prime Living"
];

export const mockPortfolio = [
  {
    id: 1,
    title: "Luxury Real Estate Rebrand",
    category: "Branding & Web",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
    result: "+215% lead generation"
  },
  {
    id: 2,
    title: "Business Setup CRM Automation",
    category: "Automation & CRM",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    result: "3x booking efficiency"
  },
  {
    id: 3,
    title: "E-Commerce Platform Launch",
    category: "Development & SEO",
    image: "https://images.unsplash.com/photo-1661956602116-aa6865609028?w=800&q=80",
    result: "$2M revenue in 6 months"
  },
  {
    id: 4,
    title: "Automobile",
    category: "Marketing & Automation",
    image: "https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800&q=80",
    result: "50K+ leads generated"
  }
];

export const mockFAQs = [
  {
    question: "What makes ImpacTech different from other agencies?",
    answer: "We combine strategic marketing with automation technology. While others just run campaigns, we build systems that work 24/7 to capture, nurture and convert leads automatically — giving you predictable growth without the manual work."
  },
  {
    question: "How long does a typical project take?",
    answer: "It varies by scope. A website typically takes 4-6 weeks, CRM implementation 2-4 weeks, and full digital transformation 3-6 months. We always provide a detailed timeline during the discovery phase and keep you updated throughout."
  },
  {
    question: "Do you work with businesses outside Dubai?",
    answer: "Absolutely! While we're based in Dubai, we serve clients across the GCC and internationally. Our processes are designed for seamless remote collaboration, and we travel when needed for key milestones."
  },
  {
    question: "What industries do you specialize in?",
    answer: "We've delivered results across real estate, hospitality, healthcare, e-commerce, professional services, and more. Our automation-first approach adapts to any industry that wants to scale growth efficiently."
  },
  {
    question: "Can you work with our existing tools and systems?",
    answer: "Yes! We integrate with virtually any CRM, marketing platform, or business tool. Whether you use Salesforce, HubSpot, custom systems or others, we'll build automation that connects everything seamlessly."
  },
  {
    question: "What kind of results can we expect?",
    answer: "Our clients average 312% growth in qualified leads within the first year. Specific results depend on your starting point and goals, but we set clear KPIs upfront and optimize relentlessly until we hit them."
  }
];
